import store from "../store";
import { engineHelper } from "../helpers/engine.helper";
import { getMinAge } from "../helpers/store.utils";

export const engineService = {
  runSimulation,
  getComplementaryCapitalsList,
  getACMAISList
};

function runSimulation(scenarioType) {
  const config = {
    eta: getMinAge(store.state.ageValue),
    PUIniziale: store.state.capitalValue,
    scenario: scenarioType,
    dirittiEmissione: 10,
    imposteSuiPremiInfortuni: 0.025,
    isClientePiuGenerali: store.state.generaliPlusValue,
    servizioBilancia: store.state.generaliBilanciaValue,
    ACMAPlusCopertura: 0,
    vuoiFamilyCare:
      store.state.extraProtectionValue.filter(a => a.id === 3).length > 0,
    familyCareCopertura:
      store.state.extraProtectionValue.filter(a => a.id === 3).length > 0
        ? store.state.extraProtectionValue.filter(a => a.id === 3)[0].value
        : 0,
    vuoiTCMPU:
      store.state.extraProtectionValue.filter(a => a.id === 1).length > 0,
    TCMPUCopertura:
      store.state.extraProtectionValue.filter(a => a.id === 1).length > 0
        ? store.state.extraProtectionValue.filter(a => a.id === 1)[0].value
        : 0,
    vuoiACMA:
      store.state.extraProtectionValue.filter(a => a.id === 2).length > 0,
    ACMAPUCopertura:
      store.state.extraProtectionValue.filter(a => a.id === 2).length > 0
        ? store.state.extraProtectionValue.filter(a => a.id === 2)[0].value
        : 0,
    orizzonteTemporale: store.state.yearValue,
    tutelaClima:
      store.state.areaValue.filter(a => a.id === 1).length > 0
        ? (2 * store.state.areaValue.filter(a => a.id === 1)[0].value) /
          store.state.capitalValue
        : 0,
    pariOpportunita:
      store.state.areaValue.filter(a => a.id === 2).length > 0
        ? (2 * store.state.areaValue.filter(a => a.id === 2)[0].value) /
          store.state.capitalValue
        : 0,
    consumoResponsabile:
      store.state.areaValue.filter(a => a.id === 3).length > 0
        ? (2 * store.state.areaValue.filter(a => a.id === 3)[0].value) /
          store.state.capitalValue
        : 0,
    saluteBenessere:
      store.state.areaValue.filter(a => a.id === 4).length > 0
        ? (2 * store.state.areaValue.filter(a => a.id === 4)[0].value) /
          store.state.capitalValue
        : 0,
    crescitaSostenibile:
      store.state.areaValue.filter(a => a.id === 5).length > 0
        ? (2 * store.state.areaValue.filter(a => a.id === 5)[0].value) /
          store.state.capitalValue
        : 0
  };
  const data = engineHelper.execSimulation(config);
  // console.log("config " + scenarioType, config);
  // console.log("config json " + scenarioType, JSON.stringify(config));
  // console.log("data", data);
  return data;
}

function getComplementaryCapitalsList(capilatValue) {
  return engineHelper.getCapitaliComplementari(capilatValue);
}

function getACMAISList(capitalValue) {
  return engineHelper.getACMAIS(capitalValue);
}
